export enum ClientType {
  ORGANISATION_SERVICE,
  AUTHORING_AGGREGATOR,
  GRAPHQL_GATEWAY,
  MARKETPLACE,
}
